import store from '../store';
import { updateRequestVerificationToken } from './requestVerificationTokenUtility';
import { load as loadCart, setShowMiniCart } from '../Actions/Cart.action';

window.addEventListener('pageshow', (e) => {
  const nav = performance.getEntriesByType(
    'navigation'
  )[0] as PerformanceNavigationTiming;

  if (
    e.persisted ||
    (nav?.transferSize === 0 && nav.type === 'back_forward')
  ) {
    updateRequestVerificationToken();
    store.dispatch(loadCart());
    store.dispatch(setShowMiniCart(false));
  }
});
